import React from 'react';

export const PromotionIcon = ({
  borderColor = '#D5CBF6',
  shadowColor = '#AD9BEB',
  innerColor = '#5B37D2',
  outerColor = '#9880E5'
}) => {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ filter: `drop-shadow(0px 0px 10px ${shadowColor})` }}
    >
      <path
        d="M12.3523 7.37272C13.3424 4.8743 16.4105 3.89146 18.6791 5.41324L20.9165 6.91378L20.9897 6.95571C21.1653 7.0421 21.373 7.04252 21.5506 6.9529L23.956 5.73755L24.1937 5.62692C26.5807 4.59524 29.34 5.9425 29.9942 8.45925L30.0532 8.71472L30.574 11.359C30.6181 11.5817 30.7788 11.7631 30.9945 11.834L33.5537 12.6756L33.8003 12.7653C36.2181 13.7235 37.2169 16.6281 35.8995 18.8705L35.7598 19.092L34.2593 21.3294C34.1327 21.5181 34.1178 21.7607 34.2202 21.9635L35.4355 24.369L35.5461 24.6067C36.5778 26.9935 35.2304 29.7529 32.7138 30.4072L32.4583 30.4661L29.8141 30.987C29.6192 31.0255 29.4552 31.1529 29.3698 31.3287L29.3381 31.4078L28.4966 33.9669C27.6435 36.5619 24.6196 37.6736 22.3025 36.3125L22.0801 36.1731L19.8427 34.6726C19.6777 34.5618 19.4718 34.5363 19.2871 34.6003L19.2095 34.6331L16.8041 35.8485C14.2874 37.1198 11.2522 35.6376 10.7069 32.8713L10.1861 30.2271L10.1643 30.1457C10.1101 29.9869 9.99442 29.8563 9.8434 29.7831L9.76528 29.7511L7.20611 28.9095C4.5274 28.029 3.42913 24.8347 4.99996 22.4931L6.5005 20.2557L6.54275 20.1833C6.61687 20.0328 6.62767 19.8586 6.57279 19.7L6.53994 19.6225L5.32459 17.217C4.05325 14.7003 5.53536 11.665 8.30176 11.1199L10.946 10.599L11.0273 10.5773C11.2124 10.5141 11.359 10.3673 11.421 10.1786L12.2626 7.61939L12.3523 7.37272Z"
        fill="url(#paint0_linear_7341_50616)"
        stroke={borderColor}
        strokeWidth="2"
      />
      <path
        d="M24.2175 17.0434L19.8072 26.0756C19.3767 26.9574 18.3127 27.3232 17.4309 26.8926C16.5491 26.462 16.1833 25.3981 16.6139 24.5163L21.0242 15.4842C21.4548 14.6024 22.5187 14.2366 23.4005 14.6671C24.2823 15.0977 24.6481 16.1616 24.2175 17.0434Z"
        fill="url(#paint1_linear_7341_50616)"
      />
      <path
        d="M17.5799 17.997C17.899 18.925 17.4054 19.936 16.4774 20.255C15.5494 20.5741 14.5384 20.0805 14.2193 19.1525C13.9003 18.2245 14.3939 17.2135 15.3219 16.8944C16.2499 16.5754 17.2609 17.069 17.5799 17.997Z"
        fill="url(#paint2_linear_7341_50616)"
      />
      <path
        d="M23.2515 23.5628C23.5706 24.4908 24.5815 24.9844 25.5095 24.6653C26.4375 24.3463 26.9312 23.3353 26.6121 22.4073C26.293 21.4793 25.2821 20.9857 24.3541 21.3047C23.426 21.6238 22.9324 22.6348 23.2515 23.5628Z"
        fill="url(#paint3_linear_7341_50616)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7341_50616"
          x1="35.578"
          y1="29.3481"
          x2="10.6027"
          y2="8.0984"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={innerColor} />
          <stop offset="1" stopColor={outerColor} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7341_50616"
          x1="24.0575"
          y1="19.1456"
          x2="15.0301"
          y2="29.641"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_7341_50616"
          x1="24.0575"
          y1="19.1456"
          x2="15.0301"
          y2="29.641"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_7341_50616"
          x1="24.0575"
          y1="19.1456"
          x2="15.0301"
          y2="29.641"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const TrainingIcon = ({
  borderColor = '#D5CBF6',
  shadowColor = '#2AA14166',
  innerColor = '#5B37D2',
  outerColor = '#9880E5'
}) => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ filter: `drop-shadow(0px 4px 12px ${shadowColor})` }}
    >
      <path
        d="M12.9492 2.19531C13.9236 1.65261 15.1266 1.69142 16.0684 2.31152L17.1924 3.05176L17.334 3.12988C17.4815 3.19607 17.6437 3.22538 17.8066 3.21582L19.1504 3.1377L19.374 3.13281C20.4892 3.15004 21.5121 3.78508 22.0176 4.79297L22.6201 5.99512L22.7041 6.13379C22.7988 6.26494 22.9243 6.37209 23.0703 6.44531L24.2734 7.04883L24.4697 7.15625C25.3629 7.69061 25.9175 8.65071 25.9336 9.69141L25.9287 9.91504L25.8496 11.2588C25.8369 11.4759 25.8941 11.6914 26.0137 11.873L26.7539 12.9971L26.8701 13.1885C27.3767 14.098 27.3767 15.2067 26.8701 16.1162L26.7539 16.3076L26.0137 17.4316C25.8941 17.6133 25.8369 17.8288 25.8496 18.0459L25.9287 19.3896L25.9336 19.6133C25.9175 20.654 25.3629 21.6141 24.4697 22.1484L24.2734 22.2568L23.0703 22.8594C22.9243 22.9326 22.7988 23.0398 22.7041 23.1709L22.6201 23.3096L22.0176 24.5127C21.5121 25.5205 20.4891 26.1556 19.374 26.1729L19.1504 26.168L17.8066 26.0889C17.6437 26.0793 17.4815 26.1086 17.334 26.1748L17.1924 26.2529L16.0684 26.9932C15.1266 27.6133 13.9236 27.6521 12.9492 27.1094L12.7578 26.9932L11.6338 26.2529C11.4976 26.1633 11.3423 26.1083 11.1816 26.0918L11.0195 26.0889L9.67578 26.168C8.55047 26.234 7.48943 25.6658 6.91699 24.709L6.80957 24.5127L6.20605 23.3096C6.13283 23.1636 6.02568 23.0381 5.89453 22.9434L5.75586 22.8594L4.55371 22.2568C3.47877 21.7177 2.82798 20.5901 2.89844 19.3896L2.97656 18.0459L2.97363 17.8838C2.96264 17.7766 2.93475 17.6716 2.89062 17.5732L2.8125 17.4316L2.07227 16.3076C1.41087 15.3032 1.41084 14.0015 2.07227 12.9971L2.8125 11.873L2.89062 11.7314C2.93474 11.6331 2.96265 11.5281 2.97363 11.4209L2.97656 11.2588L2.89844 9.91504C2.82802 8.71461 3.47879 7.58791 4.55371 7.04883L5.75586 6.44531L5.89453 6.36133C6.02566 6.26664 6.13284 6.14111 6.20605 5.99512L6.80957 4.79297L6.91699 4.5957C7.48945 3.6389 8.55048 3.07168 9.67578 3.1377L11.0195 3.21582L11.1816 3.21289C11.3423 3.19643 11.4975 3.1414 11.6338 3.05176L12.7578 2.31152L12.9492 2.19531Z"
        fill="url(#paint0_linear_7343_60910)"
        stroke={borderColor}
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.9155 13.2689C6.95726 13.2931 7.00346 13.3117 7.0528 13.3239C7.32586 13.3889 7.59976 13.2206 7.66478 12.9475C8.12893 11.0002 9.21294 8.09186 10.168 7.72361C10.2754 7.68133 10.4136 7.65872 10.6187 7.79943C11.0126 8.07028 10.4688 8.91743 10.4633 8.92597C10.3043 9.15744 10.3639 9.474 10.5952 9.63227C10.8322 9.78977 11.1432 9.73168 11.3017 9.49995C11.6987 8.92009 12.1874 7.64327 11.1931 6.96124C10.7494 6.65679 10.2703 6.59446 9.80185 6.77505C8.00717 7.4675 6.88353 11.8416 6.67599 12.7117C6.62271 12.9351 6.7265 13.1593 6.9155 13.2689ZM15.142 11.4097C15.0566 11.4005 14.9742 11.3958 14.8947 11.3953C13.4509 10.4637 12.2194 10.123 11.7125 10.6296C11.6556 10.6865 11.6124 10.7551 11.5764 10.8303L11.5723 10.8262L5.87278 23.6654L5.87837 23.6709C5.77267 23.8757 5.94951 24.2924 6.31183 24.6552C6.67415 25.0176 7.09084 25.1944 7.29563 25.0887L7.30071 25.0938L20.1398 19.3938L20.1358 19.3892C20.2105 19.3536 20.2791 19.3104 20.3365 19.2525C20.8485 18.7405 20.4947 17.4881 19.5403 16.0244C20.5443 15.6321 21.9248 15.3132 23.5186 15.5395C23.7991 15.5812 24.0542 15.386 24.0938 15.1086C24.1334 14.8306 23.9403 14.5735 23.6624 14.5339C21.724 14.2567 20.0799 14.6824 18.9312 15.1686C18.5088 14.6197 18.015 14.0565 17.4624 13.5037C17.006 13.0475 16.5427 12.6314 16.0861 12.2625C16.4766 12.0666 16.7026 11.7274 16.7412 11.3711C16.8067 10.7649 16.3311 10.0931 15.296 9.98127C14.892 9.93757 14.7451 9.77293 14.7518 9.71093C14.7538 9.69365 14.7751 9.66266 14.8275 9.63115C14.8935 9.59202 15.047 9.53104 15.3407 9.56306C16.3768 9.67434 16.9841 9.11943 17.0502 8.51269C17.1157 7.90646 16.6401 7.23417 15.605 7.12288C15.325 7.09239 15.0755 7.29413 15.0455 7.57311C15.0145 7.8526 15.2167 8.10261 15.4957 8.1331C15.8997 8.1768 16.0455 8.34195 16.0394 8.40344C16.0374 8.42122 16.0166 8.45171 15.9642 8.48373C15.8987 8.52286 15.7437 8.58333 15.45 8.55182C14.4148 8.43952 13.8076 8.99544 13.7415 9.60117C13.7039 9.94621 13.8401 10.2907 14.115 10.5474C14.3752 10.7898 14.7462 10.9432 15.1872 10.991C15.5902 11.0347 15.7381 11.1998 15.731 11.2613C15.7249 11.3233 15.545 11.4529 15.142 11.4097ZM19.525 11.6519C19.525 12.0729 19.1837 12.4142 18.7627 12.4142C18.3418 12.4142 18.0005 12.0729 18.0005 11.6519C18.0005 11.231 18.3418 10.8897 18.7627 10.8897C19.1837 10.8897 19.525 11.231 19.525 11.6519ZM6.821 16.9877C7.3823 16.9877 7.83732 16.5327 7.83732 15.9714C7.83732 15.4101 7.3823 14.9551 6.821 14.9551C6.25971 14.9551 5.80469 15.4101 5.80469 15.9714C5.80469 16.5327 6.25971 16.9877 6.821 16.9877ZM23.0821 16.7336C23.0821 17.1546 22.7409 17.4958 22.3199 17.4958C21.8989 17.4958 21.5577 17.1546 21.5577 16.7336C21.5577 16.3126 21.8989 15.9714 22.3199 15.9714C22.7409 15.9714 23.0821 16.3126 23.0821 16.7336ZM17.7465 23.5937C18.1675 23.5937 18.5087 23.2525 18.5087 22.8315C18.5087 22.4105 18.1675 22.0693 17.7465 22.0693C17.3255 22.0693 16.9842 22.4105 16.9842 22.8315C16.9842 23.2525 17.3255 23.5937 17.7465 23.5937ZM21.0494 8.85707C21.0494 9.41837 20.5944 9.87339 20.0331 9.87339C19.4718 9.87339 19.0168 9.41837 19.0168 8.85707C19.0168 8.29578 19.4718 7.84076 20.0331 7.84076C20.5944 7.84076 21.0494 8.29578 21.0494 8.85707ZM22.3199 11.9062C22.7409 11.9062 23.0821 11.5649 23.0821 11.1439C23.0821 10.7229 22.7409 10.3817 22.3199 10.3817C21.8989 10.3817 21.5577 10.7229 21.5577 11.1439C21.5577 11.5649 21.8989 11.9062 22.3199 11.9062ZM21.5577 13.1764C21.5577 13.5974 21.2164 13.9387 20.7954 13.9387C20.3745 13.9387 20.0332 13.5974 20.0332 13.1764C20.0332 12.7555 20.3745 12.4142 20.7954 12.4142C21.2164 12.4142 21.5577 12.7555 21.5577 13.1764Z"
        fill="url(#paint1_linear_7343_60910)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7343_60910"
          x1="23.1061"
          y1="24.4263"
          x2="10.5743"
          y2="3.26456"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={innerColor} />
          <stop offset="1" stopColor={outerColor} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7343_60910"
          x1="23.1041"
          y1="15.2714"
          x2="1.73246"
          y2="28.7043"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const PlatformIcon = ({
  shadowColor = '#FF991F66',
  innerColor = '#FE7E07',
  outerColor = '#FCAC00'
}) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ filter: `drop-shadow(0px 4px 12px ${shadowColor})` }}
    >
      <path
        d="M10.1674 4.77323C10.757 3.26638 12.622 2.73853 13.9138 3.7129L15.5272 4.92982C15.8796 5.19564 16.3481 5.25065 16.7525 5.0737L18.6039 4.26363C20.0863 3.61501 21.7783 4.56055 22.0028 6.16299L22.2831 8.16431C22.3444 8.60148 22.6367 8.97161 23.0478 9.13245L24.9297 9.86879C26.4366 10.4584 26.9644 12.3234 25.9901 13.6152L24.7732 15.2286C24.5073 15.581 24.4523 16.0495 24.6293 16.4539L25.4394 18.3053C26.088 19.7877 25.1424 21.4797 23.54 21.7042L21.5387 21.9845C21.1015 22.0458 20.7314 22.3381 20.5705 22.7492L19.8342 24.6311C19.2446 26.138 17.3796 26.6658 16.0878 25.6915L14.4744 24.4746C14.1219 24.2087 13.6535 24.1537 13.2491 24.3307L11.3977 25.1407C9.9153 25.7894 8.22327 24.8438 7.9988 23.2414L7.71845 21.2401C7.65721 20.8029 7.36488 20.4328 6.95378 20.2719L5.07184 19.5356C3.56499 18.946 3.03714 17.081 4.01151 15.7891L5.22843 14.1758C5.49425 13.8233 5.54926 13.3549 5.3723 12.9505L4.56224 11.0991C3.91362 9.61669 4.85916 7.92466 6.4616 7.70019L8.46292 7.41985C8.90009 7.35861 9.27022 7.06627 9.43106 6.65517L10.1674 4.77323Z"
        fill="url(#paint0_linear_7343_59563)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5996 8.04246L18.7599 7.97625L18.2631 7.29563C18.1807 7.18248 18.0368 7.13292 17.9021 7.17105C17.7678 7.20908 17.6712 7.3267 17.66 7.46633L17.5939 8.30627L16.9132 8.80277C16.8001 8.88546 16.7506 9.02936 16.7886 9.16374C16.8266 9.29813 16.9443 9.39503 17.0839 9.40589L17.9238 9.472L18.4203 10.1527C18.503 10.2658 18.6469 10.3153 18.7813 10.2773C18.9157 10.2393 19.0122 10.1216 19.0234 9.98201L19.0895 9.14207L19.7703 8.64558C19.8833 8.56288 19.9329 8.41898 19.8948 8.2846C19.8568 8.15022 19.7392 8.05364 19.5996 8.04246ZM19.9687 13.4299L16.3059 13.2002L13.965 9.67589C13.8748 9.53997 13.7001 9.47867 13.5358 9.52518C13.3715 9.57168 13.2549 9.7154 13.2493 9.87845L13.1029 14.1067L10.1034 16.222C9.97101 16.3156 9.91127 16.4759 9.95347 16.6251C9.99558 16.7738 10.1307 16.8798 10.2924 16.8897L13.9536 17.1195L16.3284 20.7619C16.4182 20.8994 16.5935 20.9617 16.7593 20.9148C16.9248 20.8679 17.0418 20.7229 17.0462 20.5583L17.1598 16.2116L20.158 14.0971C20.2898 14.0045 20.3498 13.8437 20.3076 13.6946C20.2655 13.5458 20.1302 13.4403 19.9687 13.4299ZM12.9226 20.0139L12.1159 20.0029L11.5848 19.2305C11.5149 19.1284 11.3658 19.0862 11.2208 19.1272C11.0758 19.1683 10.971 19.2824 10.9646 19.4058L10.917 20.3419L10.2361 20.7739C10.1204 20.8472 10.0643 20.968 10.0949 21.0762C10.1255 21.1844 10.2366 21.2578 10.3735 21.2596L11.1758 21.271L11.7327 22.126C11.8013 22.2308 11.9524 22.2752 12.1 22.2335C12.2475 22.1917 12.3529 22.0746 12.3564 21.9493L12.3826 20.9292L13.0599 20.499C13.1756 20.426 13.2318 20.3052 13.2011 20.197C13.1705 20.0888 13.0595 20.0154 12.9226 20.0139Z"
        fill="url(#paint1_linear_7343_59563)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7343_59563"
          x1="26.0269"
          y1="21.7393"
          x2="8.20588"
          y2="4.79017"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={innerColor} />
          <stop offset="1" stopColor={outerColor} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7343_59563"
          x1="20.4187"
          y1="12.714"
          x2="8.56239"
          y2="25.9585"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
